import { BASE_URL, requests } from "./base"

const GET_ARTICLES = `${BASE_URL}/admin/knowladge/articles`
const GET_ARTICLE_BY_ID = `${BASE_URL}/admin/knowladge/article/id`
const SEARCH_ARTICLE = `${BASE_URL}/admin/knowladge/article/search`
const CREATE_ARTICLE = `${BASE_URL}/admin/knowladge/article/create`
const EDIT_ARTICLE = `${BASE_URL}/admin/knowladge/article/edit`
const GET_CATEGORIES = `${BASE_URL}/admin/knowladge/categories`
const CREATE_CATEGORY = `${BASE_URL}/admin/knowladge/category/create`
const EDIT_CATEGORY = `${BASE_URL}/admin/knowladge/category/edit`
const GET_CATEGORY_BY_ID = `${BASE_URL}/admin/knowladge/category/id`

interface GetAllArticlesResponse {
  success: boolean
  articles: KnowladgebaseArticleResponse[]
  currentPage: number
  totalPages: number
}

export const getAllArticles = async (page: number = 0) => {
  const res = await requests.get<GetAllArticlesResponse>(
    `${GET_ARTICLES}?page=${page}`,
    undefined,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}
interface SearchArticleResponse {
  success: boolean
  articles: KnowladgebaseArticleResponse[]
}

export const searchArticle = async (query: string) => {
  const res = await requests.post<SearchArticleResponse>(
    `${SEARCH_ARTICLE}`,
    {
      query,
    },
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}

export const getArticleById = async (id: string) => {
  const res = await requests.get<KnowladgebaseArticle>(
    `${GET_ARTICLE_BY_ID}/${id}`,
    undefined,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}

interface CreateArticleResponse {
  success: boolean
  id: number
  error?: { id: number; message: string }
}

export const createArticle = async (article: Partial<KnowladgebaseArticle>) => {
  const res = await requests.post<CreateArticleResponse>(
    `${CREATE_ARTICLE}`,
    article,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}
interface EditArticleResponse {
  success: boolean
  id: number
  error?: { id: number; message: string }
}

export const editArticle = async (article: Partial<KnowladgebaseArticle>) => {
  const res = await requests.post<EditArticleResponse>(
    `${EDIT_ARTICLE}`,
    article,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}

export const getAllCategories = async () => {
  const res = await requests.get<KnowladgebaseCategory[]>(
    `${GET_CATEGORIES}`,
    undefined,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}

interface CreateCategoryResponse {
  success: boolean
  id: number
  error?: { id: number; message: string }
}

export const createCategory = async (
  category: Partial<KnowladgebaseCategory>,
) => {
  const res = await requests.post<CreateCategoryResponse>(
    `${CREATE_CATEGORY}`,
    category,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}
interface EditCategoryResponse {
  success: boolean
}

export const editCategory = async (
  category: Partial<KnowladgebaseCategory>,
) => {
  const res = await requests.post<EditCategoryResponse>(
    `${EDIT_CATEGORY}`,
    category,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}

export const getCategoryById = async (id: string) => {
  const res = await requests.get<KnowladgebaseCategory>(
    `${GET_CATEGORY_BY_ID}/${id}`,
    undefined,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    },
  )
  return res
}
